import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service'; 
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  submitted = false;
  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public commonService: CommonService,
    public loginLayoutService: LoginLayoutService,
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get f() {
    return this.forgotPasswordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
  
    if (this.forgotPasswordForm.invalid) {
      return;
    }
  
    const emailData = this.forgotPasswordForm.value;
  
    this.loginLayoutService.forgotPassword(emailData).subscribe(
      (Response: any) => {
        if (Response.code === 1) {
          this.commonService.notifier.notify('success', 'Password reset instructions sent to your email.');
          this.router.navigate(['reset-password-verify-otp'], {
            queryParams: { userId: Response.data.userId, isForgotPassword: true }
        });
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
      (error) => {
        // console.log('API Error:', error); // Log error to the console
        this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
      }
    );
  }
  
}
